import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { isBlockingSanction, sanctionBannerText } from '../../utils/brand-sanction';
import { useOrdererSanction } from './orderer-sanction-context';

/** Thanh báo nổi bật khi người đặt đơn đang bị khoá tạo việc (spec §5). Không bị khoá thì không hiện gì. */
const OrdererSanctionBanner: React.FC = () => {
  const { active, legacyBan } = useOrdererSanction();
  const text =
    active && isBlockingSanction(active, Date.now())
      ? sanctionBannerText(active)
      : legacyBan
      ? `Tài khoản đã bị khoá vĩnh viễn khỏi sàn hợp tác.${legacyBan.reason ? ` Lý do: ${legacyBan.reason}` : ''}`
      : null;
  if (!text) return null;
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700 dark:border-rose-900/40 dark:bg-rose-900/20 dark:text-rose-300"
    >
      <ShieldAlert size={18} className="mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold">{text}</p>
        <p className="mt-1 text-xs">
          Bạn vẫn theo dõi được việc creator đang làm, duyệt bài nộp, giải trình kháng cáo, đóng chiến dịch và chi trả như
          bình thường.
        </p>
      </div>
    </div>
  );
};

export default OrdererSanctionBanner;
